import { StationName } from '../station_types'

export type StationSelectValue = { id: string; label: string }

export const transformStationDeviceToSelectValue = (station: StationName): StationSelectValue => {
    return {
        id: station.station_name,
        label: station.station_name
    }
}
export const transformStationSelectValueToDevice = (
    selectValue: StationSelectValue | undefined | null
): StationName | null => {
    if (!selectValue) {
        return null
    }

    return {
        __typename: 'station',
        station_name: selectValue.id
    }
}
